import { cn } from "@/lib/utils/cn";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-muted text-muted-foreground",
        secondary:
          "border-transparent bg-muted text-secondary-foreground hover:bg-muted/80",
        destructive: "border-destructive/20 bg-destructive/10 text-destructive",
        warning: "border-amber-200 bg-amber-50 text-amber-700",
        success: "border-emerald-200 bg-emerald-50 text-emerald-700",
        muted: "bg-muted text-muted-foreground",
        blue: "border-transparent bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-300",
        green:
          "border-transparent bg-green-100 text-green-800 dark:bg-green-950 dark:text-green-300",
        amber:
          "border-transparent bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300",
        red: "border-transparent bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-300",
        purple:
          "border-transparent bg-purple-100 text-purple-800 dark:bg-purple-950 dark:text-purple-300",
        rose: "border-transparent bg-rose-100 text-rose-800 dark:bg-rose-950 dark:text-rose-300",
        cyan: "border-transparent bg-cyan-100 text-cyan-800 dark:bg-cyan-950 dark:text-cyan-300",

        outline: "text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
